<template>

  <v-container style="padding-top:0px; padding-bottom:0px;">
    <v-layout>
      <v-flex xs6 style="margin-top:-1.5em;">
        <img src="https://jm-a.be/img/jm-a_jean-marot-avocat-huy_logo.png" align="left">
      </v-flex>
      <v-flex xs6 mt-3 class="text-xs-right">
        <v-btn href="tel:+3285318175" dark color="primary"><v-icon>phone</v-icon>&nbsp;&nbsp; Appeler</v-btn>
        <p style="margin-top:1.7em;"><a href="https://jm-a.be">Retourner sur jm-a.be</a></p>
      </v-flex>
    </v-layout>
    <v-breadcrumbs divider="/" class="text-xs-center">
      <v-breadcrumbs-item href="https://jm-a.be">
        JM-A
      </v-breadcrumbs-item>
      <v-breadcrumbs-item href="https://jm-a.be/circulation">
        Circulation
      </v-breadcrumbs-item>
      <v-breadcrumbs-item>
        Ethylotest virtuel
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <h1 class="primary--text text-xs-center">Ethylotest virtuel</h1>
  </v-container>


</template>

<script>
export default {
  name: 'MobileHeader'
}  
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/MobileHeader.vue